export var APPLICATION_WIDGET_PAGE_E;
(function (APPLICATION_WIDGET_PAGE_E) {
  APPLICATION_WIDGET_PAGE_E["APPLICATION"] = "application";
  APPLICATION_WIDGET_PAGE_E["DOCUMENTS"] = "documents";
  APPLICATION_WIDGET_PAGE_E["SUBMIT"] = "submit";
})(APPLICATION_WIDGET_PAGE_E || (APPLICATION_WIDGET_PAGE_E = {}));